// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, get, patch } from "@insite/client-framework/Services/ApiService";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { BaseModel, CatalogPageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

const catalogPagesUrl = "/api/v1/catalogpages";
const productsUrl = "/api/v2/products";
const customerPartApi = "/api/pace/CustomerPartNumber";

export interface CustomerPartNumberParameters extends ApiParameter {
    CustomerId: string;
    ProductId: string;
    Value: string;
}

export interface CustomerPartNumberApiResponse {
    successful: boolean;
    error?: string;
}

export async function updateCustomerPartProduct(
    parameters: CustomerPartNumberParameters,
): Promise<CustomerPartNumberApiResponse> {
    try {
        await patch<CustomerPartNumberParameters & BaseModel>(customerPartApi, parameters);
        return {
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            error: error.message,
        };
    }
}

export async function getProductByPath(parameter: GetProductByPathApiV2Parameter) {
    const result = await get<CatalogPageModel>(`${catalogPagesUrl}`, {
        path: parameter.path,
    } as ApiParameter);
    const productModel = await get<ProductModel>(`${productsUrl}/${result.productId}`, {
        expand: parameter.expand,
        additionalExpands: parameter.additionalExpands,
        includeAttributes: parameter.includeAttributes,
        addToRecentlyViewed: parameter.addToRecentlyViewed,
        // XNG-Changes
        ...((parameter as any).nocache === true ? { timestamp: new Date().getTime() } : {}),
    } as ApiParameter);

    return productModel;
}
